var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';
import BlockButton from '../Utilities/BlockButton';
import { teal } from '../colors';
const CarouselSlide = (_a) => {
    var { active, animateIn, animateOut, direction, index, onCarouselClick, showZoomOverlay, zoomOverlayContent } = _a, props = __rest(_a, ["active", "animateIn", "animateOut", "direction", "index", "onCarouselClick", "showZoomOverlay", "zoomOverlayContent"]);
    const [currentDirection, setDirection] = useState(null);
    const [classes, setClasses] = useState({});
    const startAnimation = useCallback(() => {
        const newDirection = direction === 'prev' ? 'right' : 'left';
        setDirection(newDirection);
    }, [direction, setDirection]);
    useEffect(() => {
        const initialClasses = {
            item: true,
            clickable: onCarouselClick && active && !animateIn,
            active: (active && !animateIn) || animateOut,
            'overlay-container': showZoomOverlay,
        };
        if (direction && active && animateIn) {
            initialClasses[direction] = true;
        }
        if (currentDirection && (animateIn || animateOut)) {
            initialClasses[currentDirection] = true;
        }
        setClasses(initialClasses);
    }, [onCarouselClick, active, animateIn, animateOut, showZoomOverlay, direction, currentDirection]);
    useEffect(() => {
        setDirection(null);
        setTimeout(() => startAnimation(), 20);
    }, [active, startAnimation]);
    const onClick = () => {
        onCarouselClick && onCarouselClick(index);
    };
    const zoomContent = zoomOverlayContent || React.createElement("span", null, "Zoom In");
    return (React.createElement(BlockButton, { onClick: onClick, className: cx(classes) },
        props.children,
        showZoomOverlay ? (React.createElement("div", { className: "overlay flex-center", style: { color: teal.base } }, zoomContent)) : null));
};
CarouselSlide.propTypes = {
    active: PropTypes.bool,
    index: PropTypes.number,
    animateOut: PropTypes.bool,
    animateIn: PropTypes.bool,
    direction: PropTypes.string,
    onCarouselClick: PropTypes.func,
    showZoomOverlay: PropTypes.bool,
    zoomOverlayContent: PropTypes.node,
    children: PropTypes.node,
};
export default CarouselSlide;
